import React from 'react';

import ShopSearchDrawerControls from './shop-search-drawer-controls';

import '../../styles/search/shop-search-drawer.scss';

const ShopSearchDrawer = (props) => (
  <div className={`shop-search-drawer ${props.expanded ? 'expanded': ''}`}>
    <div className="search-bar">
      <ShopSearchDrawerControls
        searchFieldRef={props.searchFieldRef}
        expanded={ props.expanded }
      />
    </div>
  </div>
);

export default ShopSearchDrawer;
